import React from 'react';
import { withFormsy } from 'formsy-react';
import { InputAdornment, styled, TextField } from '@mui/material';

import { type FilterItemBaseProps } from '../FilterItemManager';

type NumberFilterItemProps = {
	unit?: string;
} & FilterItemBaseProps<string | number>;

const StyledTextField = styled(TextField)(({ theme }) => ({
	'& > .MuiOutlinedInput-root > .MuiOutlinedInput-input': {
		paddingTop: 12,
		paddingBottom: 12
	}
}));

function NumberFilterItem(props: NumberFilterItemProps) {
	const isDisabled = !!props.defaultValue;

	function handleChange(event) {
		props.sendChange(event.target.value);
	}

	return (
		<StyledTextField
			className={props.className}
			name={props.name}
			variant="outlined"
			size="small"
			type="number"
			fullWidth
			autoComplete="off"
			placeholder={props.placeholder}
			slotProps={{
				inputLabel: { shrink: true },
				input: {
					endAdornment: !isDisabled && <InputAdornment position="end">{props.unit}</InputAdornment>
				}
			}}
			defaultValue={props.defaultValue || props.value}
			disabled={isDisabled}
			onBlur={handleChange}
		/>
	);
}

export default React.memo(withFormsy(NumberFilterItem));
